import type { FaireProductEntity } from "../../entity_types/product";

export const p_w4akubhrfp: FaireProductEntity = {
  token: "p_w4akubhrfp",
  type: "product",
  name: "Rouge - 8 oz",
  brandToken: "b_64vt8d44",
  brandName: "Le Feu De L'eau",
  imageUrl:
    "https://cdn.faire.com/fastly/3d183a08a737117d04dbeda608700c4e22b15b730e5715da74d1f51d75029c43.png",
  galleryImageUrls: [],
  priceDollars: 16,
  description:
    "Our 8 oz candles offer the same high-quality scents you love in a minimalist design, reducing waste and keeping costs down. Each candle is wrapped in paper for a simple, sustainable, and affordable presentation.\n\nProduct Notes:\n• Cruelty-free\n• Coconut apricot wax\n• Natural fragrance / Lead-free cotton wicks\n• No phthalates, parabens, sulfates, ethanol, mineral oils, petroleum distillates, or preservatives\n• Poured in small batches in Los Angeles\n• Our most minimal candle with reduced packaging, wrapped in paper.\n\nBurn Time: 40+ hrs\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:44.018Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
